// actionTypes.js

export const ClientActionTypes = {
    SET_DATA: "CLIENTS/SET_DATA",
    ADD_ONE: "CLIENTS/ADD_ONE",
    UPDATE_ONE: "CLIENTS/UPDATE_ONE",
    DELETE_ONE: "CLIENTS/DELETE_ONE",
    SET_LOADING: "CLIENTS/SET_LOADING",
    SET_ERROR: "CLIENTS/SET_ERROR"
};

export const CommercialControlActionTypes = {
    COMMERCIAL_RESET: "COMMERCIAL_CONTROL/RESET",
    COMMERCIAL_USAGE_REQUEST: "COMMERCIAL_CONTROL/USAGE_REQUEST",
    COMMERCIAL_USAGE_SUCCESS: "COMMERCIAL_CONTROL/USAGE_SUCCESS",
    COMMERCIAL_USAGE_FAILURE: "COMMERCIAL_CONTROL/USAGE_FAILURE",
    COMMERCIAL_PREFLIGHT_REQUEST: "COMMERCIAL_CONTROL/PREFLIGHT_REQUEST",
    COMMERCIAL_PREFLIGHT_SUCCESS: "COMMERCIAL_CONTROL/PREFLIGHT_SUCCESS",
    COMMERCIAL_PREFLIGHT_FAILURE: "COMMERCIAL_CONTROL/PREFLIGHT_FAILURE",
    COMMERCIAL_SET_ACTIVE_RESERVATION: "COMMERCIAL_CONTROL/SET_ACTIVE_RESERVATION",
    COMMERCIAL_CLEAR_ACTIVE_RESERVATION: "COMMERCIAL_CONTROL/CLEAR_ACTIVE_RESERVATION",
    COMMERCIAL_OPEN_GATE_MODAL: "COMMERCIAL_CONTROL/OPEN_GATE_MODAL",
    COMMERCIAL_CLOSE_GATE_MODAL: "COMMERCIAL_CONTROL/CLOSE_GATE_MODAL",
    COMMERCIAL_SET_PARTIAL_ANALYSIS_DECISION: "COMMERCIAL_CONTROL/SET_PARTIAL_ANALYSIS_DECISION",
    COMMERCIAL_CLEAR_PARTIAL_ANALYSIS_DECISION: "COMMERCIAL_CONTROL/CLEAR_PARTIAL_ANALYSIS_DECISION",
};

export const UserActionTypes = {
    SET_FIRST_LOGIN: "USERS/SET_FIRST_LOGIN",
    SET_POLICY_ACCEPTANCE: "USERS/SET_POLICY_ACCEPTANCE",
    SET_AUTH: "USERS/SET_AUTH",
    SET_USER: "USERS/SET_USER",
    SET_USERS: "USERS/SET_USERS",
    SET_CURRENT_USER: "USERS/SET_CURRENT_USER",
    ADD_ONE: "USERS/ADD_ONE",
    UPDATE_ONE: "USERS/UPDATE_ONE",
    DELETE_ONE: "USERS/DELETE_ONE",
    SET_LOADING: "USERS/SET_LOADING",
    SET_LOADING_AUTH: "USERS/SET_LOADING_AUTH",
    SET_ERROR: "USERS/SET_ERROR"
};

export const CritereActionTypes = {
    SET_DATA: "CRITERES/SET_DATA",
    ADD_ONE: "CRITERES/ADD_ONE",
    UPDATE_ONE: "CRITERES/UPDATE_ONE",
    DELETE_ONE: "CRITERES/DELETE_ONE",
    SET_LOADING: "CRITERES/SET_LOADING",
    SET_ERROR: "CRITERES/SET_ERROR"
};

export const DocumentActionTypes = {
    SET_CURRENT_VERSION: "DOCUMENTS/SET_CURRENT_VERSION",
    SET_VERSION_CONTENT: "DOCUMENTS/SET_VERSION_CONTENT",
    SET_LOADING: "DOCUMENTS/SET_LOADING",
    SET_ERROR: "DOCUMENTS/SET_ERROR",
    ADD_VERSION: "DOCUMENTS/ADD_VERSION",
    DELETE_AMENDMENT: "DOCUMENTS/DELETE_AMENDMENT",
    ADD_AMENDMENT: "DOCUMENTS/ADD_AMENDMENT",
    SET_VERSION_LOADING: "DOCUMENTS/SET_VERSION_LOADING",
    SET_GLOBAL_LOADING: "DOCUMENTS/SET_GLOBAL_LOADING",
    SET_VERSION_STATUS: "DOCUMENTS/SET_VERSION_STATUS",
    SET_VERSION_TITLE: "DOCUMENTS/SET_VERSION_TITLE",

};

// Dans actionTypes.js
export const StageActionTypes = {
    SET_ERROR: "STAGE/SET_ERROR",
    UPDATE_CRITERION_REFS: "STAGE/UPDATE_CRITERION_REFS",
    SET_STAGE_TYPE_ANALYSE: "STAGE/SET_STAGE_TYPE_ANALYSE",
    SET_STAGE_TITLE: "STAGE/SET_STAGE_TITLE",
    SET_STAGE_CONTEXT: "STAGE/SET_STAGE_CONTEXT",
    SET_STAGE_STATUS: "STAGE/SET_STAGE_STATUS",
    SET_STAGE_MAIN_DOCUMENT: "STAGE/SET_STAGE_MAIN_DOCUMENT",
    ADD_STAGE_AMENDMENT: "STAGE/ADD_STAGE_AMENDMENT",
    REMOVE_STAGE_AMENDMENT: "STAGE/REMOVE_STAGE_AMENDMENT",
    SET_STAGE_REFERENCE_FILES: "STAGE/SET_STAGE_REFERENCE_FILES",
    ADD_REFERENCE_FILE_TO_STAGE: "STAGE/ADD_REFERENCE_FILE_TO_STAGE",
    RESET_STAGE: "STAGE/RESET_STAGE",
    FETCH_TEMPLATES_SUCCESS: "STAGE/FETCH_TEMPLATES_SUCCESS",
    SET_TEMPLATE: "STAGE/SET_TEMPLATE",
    FETCH_STAGE_DATA: "STAGE/FETCH_STAGE_DATA",
    SET_SELECTED_TEMPLATE: "STAGE/SET_SELECTED_TEMPLATE",
    TOGGLE_CRITERION_SELECTION: "STAGE/TOGGLE_CRITERION_SELECTION",
    CREATE_STAGE_TEMPLATE: "STAGE/CREATE_STAGE_TEMPLATE",
    REPLACE_CRITERIA_SELECTION: "STAGE/REPLACE_CRITERIA_SELECTION",
    ADD_VERSION: "STAGE/ADD_VERSION",
    INITIALISE_ANALYSIS: "STAGE/INITIALISE_ANALYSIS",
    SET_CRITERION: "STAGE/SET_CRITERION",
    SET_CRITERIA_STAGE: "STAGE/SET_CRITERIA_STAGE",
    FLUSH_ANALYSE: "STAGE/FLUSH_ANALYSE",
    SET_CRITERION_STATES: "STAGE/SET_CRITERION_STATES",
    SET_LABELS_VARIANT: "STAGE/SET_LABELS_VARIANT",
    ADD_CRITERION_TO_LIST: "STAGE/ADD_CRITERION_TO_LIST",
    UPDATE_CRITERION_IN_LIST: "STAGE/UPDATE_CRITERION_IN_LIST",
};

export const ReferentielActionTypes = {
    SET_DOCUMENTS: "DOCUMENT/SET_DOCUMENTS",
    SET_DOCUMENT_LOADING: "DOCUMENT/SET_DOCUMENT_LOADING",
    SET_FOLDERS: "DOCUMENT/SET_FOLDERS",
    ADD_DOCUMENT: "DOCUMENT/ADD_DOCUMENT",
    SET_LOADING_REFERENTIEL: "DOCUMENT/SET_LOADING_REFERENTIEL",
    SET_ERROR: "DOCUMENT/SET_ERROR",
};

export const ReviewActionTypes = {
    CLEAR_ANALYSES_SUMMARY: "REVIEW/CLEAR_ANALYSES_SUMMARY",
    REMOVE_ANALYSE_SUMMARY: "REVIEW/REMOVE_ANALYSE_SUMMARY",
    SET_ANALYSES_SUMMARY: "REVIEW/SET_ANALYSES_SUMMARY",
    UPDATE_ANALYSE_SUMMARY: "REVIEW/UPDATE_ANALYSE_SUMMARY",
    SET_LOADING: "REVIEW/SET_LOADING",
    SET_ERROR: "REVIEW/SET_ERROR"
};


export const TemplateActionTypes = {
    SET_TEMPLATES: "TEMPLATE/SET_TEMPLATES",
    ADD_TEMPLATE: "TEMPLATE/ADD_TEMPLATE",
    DELETE_TEMPLATE: "TEMPLATE/DELETE_TEMPLATE",
    EDIT_TEMPLATE: "TEMPLATE/EDIT_TEMPLATE",
    UPDATE_TEMPLATE: "TEMPLATE/UPDATE_TEMPLATE",
    SET_EDITING_TEMPLATE: "TEMPLATE/SET_EDITING_TEMPLATE",

    ADD_CRITERION: "TEMPLATE/ADD_CRITERION",
    REMOVE_CRITERION: "TEMPLATE/REMOVE_CRITERION",

    SET_SELECTED_TEMPLATE: "TEMPLATE/SET_SELECTED_TEMPLATE",

    SET_FILTERS: "TEMPLATE/SET_FILTERS",
    SET_SEARCH_TERM: "TEMPLATE/SET_SEARCH_TERM",
    SET_PAGE: "TEMPLATE/SET_PAGE",
    SET_ACTIVE_TAB: "TEMPLATE/SET_ACTIVE_TAB",
    SET_NEW_TEMPLATE_NAME: "TEMPLATE/SET_NEW_TEMPLATE_NAME",
    SET_ERROR: "TEMPLATE/SET_ERROR",
};

export const IAStreamActionTypes = {
    PATCH_IA_COMMENTS: "PATCH_IA_COMMENTS", //AFTER FINALIZE ADD IDS
    SET_IA_COMMENTS: "SET_IA_COMMENTS", //ETAT INITIAL MAJ des COMS au changement de version par xple
    APPEND_IA_COMMENTS: "APPEND_IA_COMMENTS", //après relance analyse, les coms regroupés, les remettre ici pour pas ecraser et éviter les doublons
    SET_ID_LOADING_COMMENTS: "SET_ID_LOADING_COMMENTS",
    RESET_IA_COMMENTS: "RESET_IA_COMMENTS",
    ADD_IA_COMMENT: "ADD_IA_COMMENT",
    REMOVE_IA_COMMENTS_BY_IDS: "REMOVE_IA_COMMENTS_BY_IDS",
    SET_IA_STREAMING: "SET_IA_STREAMING",
    FLUSH_IA_COMMENTS: "FLUSH_IA_COMMENTS",
    FINALIZE_ERROR: "FINALIZE_ERROR",
    ADD_ANALYSIS_REASONING: "ADD_ANALYSIS_REASONING",
    SET_ANALYSIS_REASONING_STATUS: "SET_ANALYSIS_REASONING_STATUS",
    RESET_ANALYSIS_REASONING: "RESET_ANALYSIS_REASONING",
    RESET_PROVIDER_SUMMARY: "RESET_PROVIDER_SUMMARY",
    APPEND_PROVIDER_SUMMARY: "APPEND_PROVIDER_SUMMARY",
    UPDATE_BATCH_ACTIVITY: "UPDATE_BATCH_ACTIVITY",
    SET_PROVIDER_SUMMARY_STATUS: "SET_PROVIDER_SUMMARY_STATUS",
    SET_ANALYSIS_STREAM_MODE: "SET_ANALYSIS_STREAM_MODE",
    START_FAST_GLOBAL_ANALYSIS: "START_FAST_GLOBAL_ANALYSIS",
    ADD_FAST_GLOBAL_OBSERVATION: "ADD_FAST_GLOBAL_OBSERVATION",
    UPSERT_FAST_GLOBAL_OBSERVATION: "UPSERT_FAST_GLOBAL_OBSERVATION",
    DISCARD_COMPARISON_PREVIEWS: "DISCARD_COMPARISON_PREVIEWS",
    DISCARD_COMPARISON_CARD_PREVIEWS: "DISCARD_COMPARISON_CARD_PREVIEWS",
    UPSERT_FAST_GLOBAL_THINKING: "UPSERT_FAST_GLOBAL_THINKING",
    START_FAST_GLOBAL_CARDS: "START_FAST_GLOBAL_CARDS",
    CLEAR_FAST_GLOBAL_OBSERVATIONS: "CLEAR_FAST_GLOBAL_OBSERVATIONS",
    RESET_FAST_GLOBAL_STREAM: "RESET_FAST_GLOBAL_STREAM",
    SET_FAST_GLOBAL_CRITERION_STATUS: "SET_FAST_GLOBAL_CRITERION_STATUS",
    SET_FAST_GLOBAL_TERMINAL: "SET_FAST_GLOBAL_TERMINAL",
    UPSERT_SUMMARY_CACHE_ENTRY: "UPSERT_SUMMARY_CACHE_ENTRY",
    CLEAR_SUMMARY_CACHE: "CLEAR_SUMMARY_CACHE",
    // ── PR#3.4.1 : enrichissement "Lire" — source de vérité unique dans le commentaire ──
    PATCH_COMMENT_ENRICHMENT: "PATCH_COMMENT_ENRICHMENT",
    RESET_REFERENCE_REVIEW: "RESET_REFERENCE_REVIEW",
    SET_REFERENCE_REVIEW_CONTEXT: "SET_REFERENCE_REVIEW_CONTEXT",
    BEGIN_REFERENCE_REVIEW_HYDRATION: "BEGIN_REFERENCE_REVIEW_HYDRATION",
    SET_REFERENCE_REVIEW_UNAVAILABLE: "SET_REFERENCE_REVIEW_UNAVAILABLE",
    SET_REFERENCE_REVIEW_HYDRATION_ERROR: "SET_REFERENCE_REVIEW_HYDRATION_ERROR",
    INTERRUPT_REFERENCE_REVIEW: "INTERRUPT_REFERENCE_REVIEW",
    UPSERT_REFERENCE_REQUIREMENT: "UPSERT_REFERENCE_REQUIREMENT",
    UPSERT_REFERENCE_VERDICT: "UPSERT_REFERENCE_VERDICT",
    SET_REFERENCE_REVIEW_TERMINAL: "SET_REFERENCE_REVIEW_TERMINAL",
    HYDRATE_REFERENCE_REVIEW_SNAPSHOT: "HYDRATE_REFERENCE_REVIEW_SNAPSHOT",
};
